<div class="body">    
    <br/>
    <div class = "container principal">
        <div class = "col-lg-12"> 
          <p>Circular N° 3623 de fecha 18.10.2021, Superintendencia de Seguridad Social. <b>Los afiliados deben conservar los originales de los documentos </b>
           <br/>
           <b>de respaldo de los beneficios solicitados digitalmente al Servicio de Bienestar, por el plazo de 5 años</b>
           <br/>
           <b> conforme a los Artículos N° 2514 y 2515 del Código Civil.</b>  Dictamen N° 467/2021. 
           <br/>    
           <br/>   
           La adulteración de datos y/o documentos contables constituye una falta grave a la probidad lo cual 
           <br/>
           conlleva expulsión total del Servicio de Bienestar y el inicio inmediato de una investigación o sumario  administrativo.   
          <br/>  
             </p>   
            <p><b>Manual de subsidio de fallecimiento: </b> <a href="{{this.linkTexto}}" target="_blank">
                Fallecimiento</a>.</p>         
        </div>
    </div>

    <br/>
    <div class="row">

        <div class="col-lg-5"> </div>

        <div class="center">
            <h1> Subsidio Fallecimiento </h1>
        </div>

        <div class="col-lg-4"> </div>

    </div>
    <br/>


    <div class="container principal">
        <div *ngIf="rol == 'ROLE_AFILIADO' || rol == 'ROLE_JUBILADO'">

            <div *ngIf="rol == 'ROLE_AFILIADO' || rol == 'ROLE_JUBILADO'">

                <div class="row">

                    <div class="col-lg-8"> </div>

                    <div class="col-lg-4">
                        <p> <b> Usuario: </b> {{nombreUsuario}} </p>
                    </div>
                </div>

            </div>

        </div>



        <div *ngIf="rol != 'ROLE_AFILIADO'" style="padding-bottom: 20px;">

            <div class="row">

                <div class="col-lg-1"> </div>

                <div class="col-lg-2">
                    <h2> Rut Afiliado </h2>
                </div>

                <div class="col-lg-4">

                    <input id="rutAfiliado" name="rutAfiliado" [(ngModel)]="buscador.rutAfiliado"
                        #rutAfiliado="ngModel" class="form-control" type="text" required
                        placeholder="Ingrese el RUT del afiliado. Ej: 11111111-1"
                        pattern="[0-9.]{7,10}[-]{1}[0-9Kk]{1}" />

                </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1">

                    <button class="btn btn-primary" id="btnvalida"
                        (click)="buscaRegistroCivil(buscador.rutAfiliado,3)" [disabled]="rutAfiliado.invalid">
                        Buscar
                    </button>

                </div>

                <div class="col-lg-1"> </div>

            </div>
            <div class="row">

                <div class="col-lg-5"> </div>

                <div class="col-lg-5">
                    <h2>{{this.afiliado.nombreAfiliado}} {{this.afiliado.rutAfiliado}}
                    </h2>
                </div>

            </div>
        </div>
        <br/>
        <form #fallecimientoForm=ngForm>
        <div class="table-responsive" *ngIf="mostrarTitularCarga == true">

            <table class="table">

                <thead style="background-color: #0f69b4;color:white;">

                    <tr>
                        <th scope="col"> Rut </th>

                        <th scope="col"> Nombre y Apellidoss </th>

                        <th scope="col"> Parentesco </th>

                        <th scope="col"> Edad </th>

                        <th scope="col"> Sexo </th>

                        <th scope="col"> Seleccionar </th>
                    </tr>

                </thead>

                <tbody>

                    <tr [class]="i % 2 == 0 ? 'rowEven' : 'rowOdd'" *ngFor="let postulante of postulantes; let i = index">

                        <td> {{postulante.rut + '-' + postulante.dv}} </td>

                        <td> {{postulante.nombres + ' ' + postulante.apellidoPaterno }} </td>

                        <td> {{postulante.parentesco}} </td>

                        <td> {{postulante.fechaNacimiento}} </td>

                        <td> {{postulante.sexo.nombre}} </td>

                        <td>

                            <input type="radio" name="postulante" [(ngModel)]="fallecimiento.beneficiario" (click)="esconderBeneficiarios(postulante.parentesco)" value="{{i}}" required>

                        </td>

                    </tr>

                </tbody>

            </table>

        </div>

        <br/>

        <div class="row">
            <div class="col-lg-2"> </div>
            <div class="col-lg-4">
                <input type="checkbox"  id="scales" name="scales"  #scales="ngModel"
                [(ngModel)]="fallecimiento.scales" (click)="muestraRecienNacido($event)" 
                 >
                <label for="scales"> Fallecimiento Recién nacido/Mortinato</label>
            </div>
            <div class="col-lg-8"></div>
        </div>
        <div class="row" *ngIf="nacido == true">
            <div class="col-lg-2"> </div>
            <div class="col-lg-8" style="border: 1px dotted  black">
                <div class="row">

                    <div class="col-lg-1"> </div>

                    <div class="col-lg-3">
                        <label> Rut Hija/o </label>
                    </div>

                    <div class="col-lg-5">

                        <input id="rutHijo" name="rutHijo" [(ngModel)]="fallecimiento.rutHijo" #rutHijo="ngModel" class="form-control" type="text" required placeholder="Ingrese el RUT. Ej: 11111111-1" pattern="[0-9.]{7,10}[-]{1}[0-9Kk]{1}" />

                    </div>

                    <div class="col-lg-3">
                        <button class="btn btn-info" (click)="buscarHijo(fallecimiento.rutHijo)">
                            Consultar
                        </button>
                     </div>
                </div>
                <br/>

               
                <div class="row">

                    <div class="col-lg-1"> </div>

                    <div class="col-lg-3">
                        <label>Nombre Completo </label>
                    </div>

                    <div class="col-lg-5">

                        <input id="nombreHijo" name="nombreHijo"  
                        [disabled] = "fallecimiento.nomNacDeshabilitado" [(ngModel)]="fallecimiento.nombreHijo" #nombreHijo="ngModel" class="form-control" type="text" required placeholder="Nombre del hijo"/>

                    </div>

                    <div class="col-lg-1"> </div>
                </div>
            </div>
            <div class="col-lg-2"> </div>
        </div>
        <br/>
        <div class="row">

            <div class="col-lg-1"> </div>

            <div class="col-lg-8">
                <h2> Datos Fallecimiento </h2>
            </div>

            <div class="col-lg-3"> </div>

        </div>
        <br/>

        <div class="row line">

            <div class="col-lg-1"> </div>

            <div class="col-lg-3">
                <p> Fecha defunción </p>
            </div>

            <div class="col-lg-5">

                <input class="form-control"  id="fechaFallecimiento" name="fechaFallecimiento" #fechaFallecimiento="ngModel"
                [(ngModel)]="fallecimiento.fechaFallecimiento" required type="date">

            </div>

            <div class="col-lg-3"> </div>

        </div>

        <div class="row line">

            <div class="col-lg-1"> </div>

            <div class="col-lg-3">
                <p> Adjuntar </p>
            </div>

            <div class="col-lg-5">

                <input type="file" class="form-control-file" name="archivo" required
                    accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="fallecimiento.archivoTest"
                    (change)="seleccionaArchivo($event, 0)">

            </div>

            <div class="col-lg-1"> </div>

            <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>

            <div class="col-lg-1"> </div>

        </div>
        <br />
        <div *ngIf="cantidadArchivos > 1" class="row line">

            <div class="col-lg-1"> </div>

            <div class="col-lg-3">
                <p> Adjuntar (2) </p>
            </div>

            <div class="col-lg-5">

                <input type="file" class="form-control-file" name="archivo2" 
                    accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="fallecimiento.archivoTest2"
                    (change)="seleccionaArchivo($event, 1)">

            </div>

            <div class="col-lg-1"> </div>

            <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>

            <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

        </div>
        <br />
        <div *ngIf="cantidadArchivos > 2" class="row line">

            <div class="col-lg-1"> </div>

            <div class="col-lg-3">
                <p> Adjuntar (3) </p>
            </div>

            <div class="col-lg-5">

                <input type="file" class="form-control-file" name="archivo3" required
                    accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="fallecimiento.archivoTest3"
                    (change)="seleccionaArchivo($event, 2)">

            </div>

            <div class="col-lg-1"> </div>

            <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>

            <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

        </div>
        <br />
        <div *ngIf="cantidadArchivos > 3" class="row line">

            <div class="col-lg-1"> </div>

            <div class="col-lg-3">
                <p> Adjuntar (4) </p>
            </div>

            <div class="col-lg-5">

                <input type="file" class="form-control-file" name="archivo4" required
                    accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="fallecimiento.archivoTest4"
                    (change)="seleccionaArchivo($event, 3)">

            </div>
            <div class="col-lg-1"> </div>
            <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>

            <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

        </div>

        <br />
        <div *ngIf="cantidadArchivos > 4" class="row line">

            <div class="col-lg-1"> </div>

            <div class="col-lg-3">
                <p> Adjuntar (5) </p>
            </div>

            <div class="col-lg-5">

                <input type="file" class="form-control-file" name="archivo5" required
                    accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="fallecimiento.archivoTest5"
                    (change)="seleccionaArchivo($event, 4)">

            </div>

            <div class="col-lg-1"> </div>

            <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>

            <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

        </div>

        <br />
        <div *ngIf="cantidadArchivos > 5" class="row line">

            <div class="col-lg-1"> </div>

            <div class="col-lg-3">
                <p> Adjuntar (6) </p>
            </div>

            <div class="col-lg-5">

                <input type="file" class="form-control-file" name="archivo6" required
                    accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="fallecimiento.archivoTest6"
                    (change)="seleccionaArchivo($event, 5)">

            </div>

            <div class="col-lg-1"> </div>

            <div class="col-lg-1"> </div>

            <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

        </div>
       
        <div class="row" *ngIf="mostrarBeneficiarios == true">
       <div class="col-lg-2" *ngIf="mostrarBeneficiarios == true">
            <h2> Beneficiarios: </h2>
        </div>
       <div class="col-lg-9" *ngIf="mostrarBeneficiarios == true">
          </div>
       </div>
        <div class="table-responsive"   *ngIf="mostrarBeneficiarios == true">
            <form #beneficiarioForm=ngForm>
                <div class="col-lg-1"> </div>
                <div class="col-lg-9" style="border: 1px dotted  black">
                    <div class="row">

                        <div class="col-lg-1"> </div>

                        <div class="col-lg-3">
                            <label> Rut Beneficiario </label>
                        </div>

                        <div class="col-lg-6">

                            <input id="rutBeneficiario" name="rutBeneficiario" #rutBeneficiario="ngModel" [(ngModel)]="fallecimiento.rutBeneficiario" class="form-control" type="text" required placeholder="Ingrese el RUT del beneficiado. Ej: 11111111-1" pattern="[0-9.]{7,10}[-]{1}[0-9Kk]{1}" />

                        </div>

                        <div class="col-lg-3"> </div>
                    </div>
                    <br/>
                    <div class="row">

                        <div class="col-lg-1"> </div>

                        <div class="col-lg-3">
                            <label>Nombre y Apellido  </label>
                        </div>

                        <div class="col-lg-6">

                            <input id="nombreApellidoBeneficiario" name="nombreApellidoBeneficiario" #nombreApellidoBeneficiario="ngModel" [(ngModel)]="fallecimiento.nombreApellidoBeneficiario" class="form-control" type="text" required placeholder="Ingrese el nombre y apellido del afiliado" />

                        </div>

                        <div class="col-lg-1"> </div>
                    </div>
                    <br/>
                    <div class="row">

                        <div class="col-lg-1"> </div>

                        <div class="col-lg-3">
                            <label>Parentesco</label>
                        </div>

                       <div class="col-lg-6">
                            <mat-select class="form-control" name="tipoParentesco" #tipoParentesco="ngModel" 
                                [(ngModel)]="fallecimiento.tipoParentesco" required>
        
                                <mat-option value="0">
                                    SELECCIONE....
                                </mat-option>
                                <mat-option *ngFor="let tipo of this.tipos" value="{{tipo.id}}">
                                    {{tipo.descripcion}}
                                </mat-option>
                            </mat-select>
                        </div>

                        <div class="col-lg-1"> </div>
                    </div>
                    <br/>
                    <div class="row">

                        <div class="col-lg-1"> </div>

                        <div class="col-lg-3">
                            <label>% Capital</label>
                        </div>

                        <div class="col-lg-4">

                            <input id="capitalBeneficiario" name="capitalBeneficiario" #capitalBeneficiario="ngModel" [(ngModel)]="fallecimiento.capitalBeneficiario" class="form-control" type="text" required placeholder="Ingrese porcentaje (1-100)" (keypress)="validateFormat($event)" />

                        </div>
                     
                        <div class="col-lg-9"> </div>    
                        <div class="col-lg-3" style = "text-align:right;"> <button  class="btn btn-info" (click)="agregarBeneficiario(beneficiarioForm)"> + </button> </div>       
                    </div>
                </div>           
                <div class="col-lg-2"> </div>
            </form>
        </div>
        
        <br/>

        <div class="table-responsive" *ngIf="mostrarBeneficiarios == true">          
                <table class="table">
                    <thead style="background-color: #0f69b4;color:white;">
                        <tr>
                            <th scope="col"> Rut Beneficiario</th>
                            <th scope="col"> Nombre y Apellido </th>
                            <th scope="col"> Parentesco </th>
                            <th scope="col"> % Capital </th>
                        </tr>
                    </thead>
                    <tbody>                     
                        <tr [class]="i % 2 == 0 ? 'rowEven' : 'rowOdd'" *ngFor="let plan of beneficiarios | paginate: config; let i = index">
                            <td style="text-align: left;">{{plan[0].rutBeneficiario}}</td>
                            <td style="text-align: left;">{{plan[0].nombreApellidoBeneficiario}}</td>
                            <td style="text-align: left;">{{plan[0].parentescoBeneficiario}}</td>
                            <td style="text-align: left;">{{plan[0].capitalBeneficiario}}</td>
                        </tr>
                    </tbody>

                </table>           
        </div>
     

    <br/>

    <div class="row line ">

        <div class="col-lg-5 col-sm-1 "> </div>
             <div class="col-lg-6 col-sm-1 ">
           
            <div *ngIf="rol != 'ROLE_ENCARGADO_NACIONAL' && rol != 'ROLE_EJECUTIVO' && rol != 'ROLE_EJECUTIVO_CAIP' && rol != 'ROLE_CONTABILIDAD' && rol != 'ROLE_ENCARGADO_CONTABILIDAD'">
                <button class="btn btn-success " (click)="solicitar(fallecimientoForm)">
                    Solicitar
                </button>
            </div>
        </div>



    </div>

    <!--/form-->
<!-- 
</div>-->
</form>
<div class="container " style="height:100px "> </div>